// Hai bảng khai báo của bot Telegram: nhóm/kênh → danh mục, và tài khoản được
// phép đăng. Tách khỏi modal để mỗi file còn ngắn, sửa bảng nào biết ngay chỗ.
import React from "react";
import { AutoComplete, Button, Input, Select, Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

const contains = (input, option) =>
    String(option?.label || "").toLowerCase().includes(input.toLowerCase());

/** Nút xoá 1 dòng — icon thay chữ để không dính vào nút "Thêm" bên dưới. */
const RemoveButton = ({ title, onClick }) => (
    <Button danger type="text" title={title} icon={<FontAwesomeIcon icon={faTrash} />} onClick={onClick} />
);

/** Nút thêm dòng — viền đứt, chiếm cả hàng nên luôn nằm tách khỏi dòng cuối. */
const AddButton = ({ children, onClick }) => (
    <Button
        type="dashed"
        block
        className="mt-1"
        icon={<FontAwesomeIcon icon={faPlus} />}
        onClick={onClick}
    >
        {children}
    </Button>
);

/** Nhóm/kênh nào → bài vào danh mục nào (threadId để nhắm 1 topic trong nhóm). */
export function TelegramChatList({ chats, chatOptions, categoryOptions, onChange, onRemove, onAdd }) {
    return (
        <>
            {chats.map((chat, i) => (
                <Space key={i} className="mb-2" wrap>
                    <AutoComplete
                        style={{ width: 260 }}
                        placeholder="chọn nhóm bot vừa nghe / gõ chatId"
                        options={chatOptions}
                        value={chat.chatId}
                        onChange={(chatId) => onChange(i, { chatId })}
                        filterOption={contains}
                    />
                    <Input
                        style={{ width: 150 }}
                        placeholder="threadId (bỏ trống = cả nhóm)"
                        value={chat.threadId || ""}
                        onChange={(e) => onChange(i, { threadId: e.target.value })}
                    />
                    <Select
                        style={{ width: 200 }}
                        placeholder="Danh mục"
                        value={chat.category || undefined}
                        onChange={(category) => onChange(i, { category })}
                        options={categoryOptions}
                    />
                    <RemoveButton title="Xoá nhóm này" onClick={() => onRemove(i)} />
                </Space>
            ))}
            <AddButton onClick={onAdd}>Thêm nhóm</AddButton>
        </>
    );
}

/** Chỉ tin của những tài khoản này mới thành bài; danh mục riêng thì đè danh mục nhóm. */
export function TelegramSenderList({ senders, senderOptions, categoryOptions, onChange, onRemove, onAdd }) {
    return (
        <>
            {senders.map((sender, i) => (
                <Space key={i} className="mb-2" wrap>
                    <AutoComplete
                        style={{ width: 240 }}
                        placeholder="chọn người vừa nhắn / gõ user id"
                        options={senderOptions}
                        value={sender.id}
                        onChange={(id) => onChange(i, { id })}
                        filterOption={contains}
                    />
                    <Input
                        style={{ width: 170 }}
                        placeholder="Ghi chú (tên nhân viên)"
                        value={sender.label || ""}
                        onChange={(e) => onChange(i, { label: e.target.value })}
                    />
                    <Select
                        style={{ width: 200 }}
                        allowClear
                        placeholder="Danh mục riêng (tuỳ chọn)"
                        value={sender.category || undefined}
                        onChange={(category) => onChange(i, { category: category || null })}
                        options={categoryOptions}
                    />
                    <RemoveButton title="Xoá tài khoản này" onClick={() => onRemove(i)} />
                </Space>
            ))}
            <AddButton onClick={onAdd}>Thêm tài khoản</AddButton>
        </>
    );
}

/**
 * Thẻ trong bài → danh mục. Đè cả người gửi lẫn nhóm, nên 1 kênh Telegram + 1 người
 * đăng vẫn rải được vào nhiều tab. Thẻ tự gỡ khỏi bài trước khi lên app.
 */
export function TelegramHashtagRouteList({ routes, categoryOptions, onChange, onRemove, onAdd }) {
    return (
        <>
            {routes.map((route, i) => (
                <Space key={i} className="mb-2" wrap>
                    <Input
                        style={{ width: 200 }}
                        placeholder="vd #deal"
                        value={route.hashtag || ""}
                        onChange={(e) => onChange(i, { hashtag: e.target.value })}
                    />
                    <span className="text-gray-400">→</span>
                    <Select
                        style={{ width: 240 }}
                        placeholder="Danh mục"
                        value={route.category || undefined}
                        onChange={(category) => onChange(i, { category })}
                        options={categoryOptions}
                    />
                    <RemoveButton title="Xoá luật này" onClick={() => onRemove(i)} />
                </Space>
            ))}
            <AddButton onClick={onAdd}>Thêm luật</AddButton>
        </>
    );
}
